import {
  Card,
  CardBody,
  Input,
  Table,
  TableCell,
  TableContainer,
  TableHeader,
  Button,
} from "@windmill/react-ui";
import OnTourFeedbackTable from "components/ontourfeedback/OnTourFeedbackTable";
import DataWrapper from "./DataWrapper";
import NotFound from "components/table/NotFound";
import PageTitle from "components/Typography/PageTitle";
import useFilter from "hooks/useFilter";
import { useState, useEffect, useContext } from "react";
import ClientFeedbackServices from "services/ClientFeedbackServices";
import Somethingwentwrong from "pages/Somethingwentwrong";
import { SidebarContext } from "context/SidebarContext";
import sidebar from "routes/sidebar";
import LabelArea from "components/form/LabelArea";
import InputSearchDate from "components/form/InputSearchDate";
import { FiRefreshCcw } from "react-icons/fi";
import { useLocation } from "react-router-dom";

const OnTourFeedback = () => {
  const location = useLocation();
  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;
  const [loading, setLoading] = useState(false);
  const { isUpdate, setIsUpdate } = useContext(SidebarContext);
  const [itemsPerPage, setItemsPerPage] = useState(0);
  const [error, setError] = useState(false);
  const [clientfeedbackData, setClientFeedbackData] = useState([]);
  // const [paymentStatus, setPaymentStatus] = useState("unpaid");
  const [status, setStatus] = useState(false);
  const [cardtype, setcardtype] = useState(null);
  const [searchstartDate, setSearchStartDate] = useState(null);
  const [searchendDate, setSearchEndDate] = useState(null);

  const {
    clientfeedbackRef,
    dataTable,
    serviceData,
    handleSubmitClientFeedback,
    //   currentPage,
  } = useFilter(clientfeedbackData, itemsPerPage);
  useEffect(() => {
    if (clientfeedbackData.length !== 0) {
      setItemsPerPage(clientfeedbackData.length);
    }
  }, [clientfeedbackData]);


  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const parseDate = (str) => {
    if (!str) return null;
    const [dd, mm, yyyy] = str.split("-");
    const date = new Date(yyyy, mm - 1, dd);
    return isNaN(date.getTime()) ? null : date;
  };


  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const start = params.get("start");
    const end = params.get("end");
    const cardtypes = params.get("cardtype")
    if (cardtypes !== null) {
      setcardtype(Number(cardtypes));
    }
    const startDate = parseDate(start);
    const endDate = parseDate(end);


    if (startDate) {
      setSearchStartDate((prev) =>
        prev?.getTime() === startDate.getTime() ? prev : startDate
      );
    }

    if (endDate) {
      setSearchEndDate((prev) =>
        prev?.getTime() === endDate.getTime() ? prev : endDate
      );
    }
  }, [location.search]);

  const fetchClientFeedback = async () => {
    setLoading(true);

    try {
      const payload = {
        start_date: searchstartDate ? formatDate(searchstartDate) : "",
        end_date: searchendDate ? formatDate(searchendDate) : "",
        card_type: cardtype


      };
      // console.log("ontourfeedback", payload)

      const response = await ClientFeedbackServices.getAllOntourEscalate(
        payload
      );
      // console.log("data from the api", response);

      const updatedData =
        (response?.data || []).map(
          ({
            client_id,
            ref_no,
            is_online,
            company_name,
            arrival,
            departure,
            arrival_details,
            arrival_time,
            package_type,
            start_date,
            end_date,
            driver_name,
            driver_contact_no,
            vehicle_reg_no,
            vehicle_name,
            contact_no,
            vehicle_modal,
            arrival_via,
            departure_via,
            departure_details,
            ontour_feedback,
            vehicle_remark,
            agent_ref_no,
            days_to_complete,
            ...rest
          }) => ({
            client_id,
            ref_no,
            is_online,
            company_name,
            arrival,
            departure,
            arrival_details,
            arrival_time,
            package_type,
            start_date,
            end_date,
            driver_name,
            driver_contact_no,
            vehicle_reg_no,
            vehicle_name,
            contact_no,
            vehicle_modal,
            arrival_via,
            departure_via,
            departure_details,
            ontour_feedback:
              typeof ontour_feedback === "string"
                ? ontour_feedback
                : JSON.stringify(ontour_feedback || ""),
            vehicle_remark,
            agent_ref_no,
            days_to_complete,
            ...rest,
          })
        ) || [];
      setClientFeedbackData(updatedData);
      setStatus(response?.status);
    } catch (error) {
      console.error("Error fetching clientfeedback:", error);
      setStatus(false);
      setError(true);
      //notifyError("Failed to fetch clientfeedback. Please try again later.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!isUpdate && location.search && !searchstartDate && !searchendDate && !cardtype) {
      // console.log("Skipping initial fetch — waiting for URL date parsing");
      return;
    }
    fetchClientFeedback();
    setIsUpdate(false);
    // eslint-disable-next-line
  }, [isUpdate, searchstartDate, searchendDate, cardtype]);

  const handleSearch = () => {
    setIsUpdate(true);
  };
  const currentPage = 1;
  const isAdmin = adminInfo?.id === 1;

  const hideView = isAdmin
    ? true
    : adminInfo?.permission?.some(
      (perm) => perm.id_tab === "ontour / escalate" && perm.view === 1
    );

  const hideEdit = isAdmin
    ? true
    : adminInfo?.permission?.some(
      (perm) => perm.id_tab === "ontour / escalate" && perm.edit === 1
    );

  const hideAdd = isAdmin
    ? true
    : adminInfo?.permission?.some(
      (perm) => perm.id_tab === "ontour / escalate" && perm.add === 1
    );

  const hideExport = isAdmin
    ? true
    : adminInfo?.permission?.some(
      (perm) => perm.id_tab === "ontour / escalate" && perm.export === 1
    );

  const handleRefresh = () => {
    setIsUpdate(true);
  };

  return (
    <>
      {hideView && (
        <>
          <PageTitle sidebar={sidebar().sidebar} />
          <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
            <CardBody>
              <div className="flex flex-wrap items-center gap-3">
                <div className="flex items-center gap-3">
                  <div className="flex items-center gap-2">
                    <LabelArea label="Start Date" />
                    <div className="w-50">
                      <InputSearchDate
                        value={searchstartDate}
                        onChange={(event) => setSearchStartDate(event)}
                      />
                    </div>
                  </div>

                  <div className="flex items-center gap-2">
                    <LabelArea label="End Date" />
                    <div className="w-50">
                      <InputSearchDate
                        value={searchendDate}
                        min={searchstartDate}
                        onChange={(event) => setSearchEndDate(event)}
                      />
                    </div>
                  </div>
                </div>

                <div className="flex-1">
                  <Input
                    ref={clientfeedbackRef}
                    className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                    type="search"
                    autoComplete="off"
                    name="search"
                    placeholder="Quick Search"
                    onChange={handleSubmitClientFeedback}
                  />
                </div>

                <Button
                  className="rounded-md h-10 px-8"
                  onClick={() => {
                    handleSearch();
                  }}
                >
                  Search
                </Button>

                <FiRefreshCcw
                  onClick={() => {
                    handleRefresh();
                  }}
                  cursor="pointer"
                />
              </div>
            </CardBody>
          </Card>
          <DataWrapper loading={loading} error={error} status={status}>
            {serviceData?.length !== 0 ? (
              <TableContainer
                style={{
                  maxHeight: "65vh",
                  overflow: "scroll",
                  scrollbarWidth: "thin",
                }}
              >
                <Table>
                  <TableHeader className="custom-table-header text-center capitalize sticky top-0 z-10">
                    <tr>
                      <TableCell>Sl.No.</TableCell>
                      <TableCell>Ref No.</TableCell>
                      <TableCell>Trip Date</TableCell>
                      <TableCell>Arrival / Departure</TableCell>
                      <TableCell>Client Name</TableCell>
                      <TableCell>Days to complete</TableCell>
                      <TableCell>OnTour FeedBack</TableCell>
                      <TableCell>Service Type</TableCell>
                      <TableCell>Itinerary / Note</TableCell>
                      <TableCell>Transport Manager</TableCell>
                      <TableCell>Vehicle Remark</TableCell>
                    </tr>
                  </TableHeader>
                  <OnTourFeedbackTable
                    clientfeedback={dataTable}
                    perpage={itemsPerPage}
                    currentPage={currentPage}
                    fetchFeedback={fetchClientFeedback}
                    hideAdd={hideAdd}
                    hideView={hideView}
                    hideEdit={hideEdit}
                    hideExport={hideExport}
                  />
                </Table>
              </TableContainer>
            ) : (
              <>
                {status !== true ? (
                  <Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
                ) : (
                  <NotFound title="There are no OnTour FeedBacks." />
                )}
              </>
            )}
          </DataWrapper>
        </>
      )}
    </>
  );
};

export default OnTourFeedback;
